<div class="operation-schedule">
  <table class="schedule-table">
    <thead>
      <tr>
        <th>{{ 'location.day' | translate }}</th>
        <th>{{ 'location.opening_time' | translate }}</th>
        <th>{{ 'location.closing_time' | translate }}</th>
        <th>{{ 'location.closed' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (day of daySchedules; track day.dayKey) {
        <tr>
          <td class="day-name">
            {{ day.dayNameKey | translate }}
          </td>
          <td>
            <p-calendar
              [(ngModel)]="day.openingTimeDate"
              [timeOnly]="true"
              hourFormat="24"
              [stepMinute]="15"
              [showIcon]="true"
              iconDisplay="input"
              [disabled]="disabled || day.isClosed"
              (onSelect)="onOpeningTimeChange(day)"
              (onBlur)="onOpeningTimeChange(day)"
              placeholder="HH:MM"
              styleClass="w-full"
            ></p-calendar>
          </td>
          <td>
            <p-calendar
              [(ngModel)]="day.closingTimeDate"
              [timeOnly]="true"
              hourFormat="24"
              [stepMinute]="15"
              [showIcon]="true"
              iconDisplay="input"
              [disabled]="disabled || day.isClosed"
              (onSelect)="onClosingTimeChange(day)"
              (onBlur)="onClosingTimeChange(day)"
              placeholder="HH:MM"
              styleClass="w-full"
            ></p-calendar>
          </td>
          <td class="text-center">
            <p-checkbox
              [(ngModel)]="day.isClosed"
              [binary]="true"
              [disabled]="disabled"
              (onChange)="onScheduleChange()"
            ></p-checkbox>
          </td>
        </tr>
        @if (getValidationError(day)) {
          <tr>
            <td colspan="4" class="validation-error">
              <small class="p-error">{{ getValidationError(day) }}</small>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>
